import { useEffect, useState } from "react";

declare global {
  interface Window {
    grecaptcha: any;
  }
}

const useRecaptchaV3 = () => {
  const [isRecaptchaReady, setIsRecaptchaReady] = useState(false);

  useEffect(() => {
    if (window.grecaptcha) setIsRecaptchaReady(true);
    else {
      const script = document.createElement("script");
      script.src = `${process.env.RECAPTCHA_API_URL}?render=${process.env.RECAPTCHA_SITE_KEY}`;
      script.async = true;
      document.head.appendChild(script);
      script.onload = () => {
        setIsRecaptchaReady(true);
      };
    }
  }, []);

  const executeRecaptcha = async (action: string) => {
    if (isRecaptchaReady && window.grecaptcha)
      return await window.grecaptcha.execute(process.env.RECAPTCHA_SITE_KEY, {
        action,
      });
  };

  return executeRecaptcha;
};

export default useRecaptchaV3;
